import { RewardProgramsKey } from '@/api/Trading-Accounts/Types/RewardsHubDto'
import { GridCellProps, GridColumnProps } from '@progress/kendo-react-grid'

export interface GridColumn extends GridColumnProps {
  show: boolean
  width?: number
}

const TrackingMetricCell = (props: GridCellProps) => {
  const metrics: { id: string | number; name: string }[] =
    props.dataItem[RewardProgramsKey.trackingMetrics] ?? []

  return (
    <td className='table-columns__content'>
      {metrics.map((m, index) => (
        <span key={index}>
          {m.name}
          {index < metrics.length - 1 && <br />}
        </span>
      ))}
    </td>
  )
}

export const rewardHubProgramsColumns: GridColumn[] = [
  {
    title: 'Status',
    field: RewardProgramsKey.programStatus,
    className: 'table-columns__content',
    show: true,
    filterable: true,
    filter: 'text',
  },
  {
    title: 'Tracking Metric',
    field: RewardProgramsKey.trackingMetrics,
    className: 'table-columns__content',
    show: true,
    filterable: true,
    filter: 'text',
    cell: TrackingMetricCell,
  },
  {
    title: '# of Tiers',
    field: RewardProgramsKey.numberOfTiers,
    className: 'table-columns__content',
    show: true,
    filterable: true,
    filter: 'text',
  },
]
